import React, { useEffect, useState } from "react";
import DateSelector from "../../../components/shared/fields/DateSelector";
import Box from "../../../images/boxes.svg";
import BoxGreen from "../../../images/box_green.svg";
import GridCard from "../../../components/shared/gridCard/GridCard";
import { Col, Row } from "react-bootstrap";
import InfoCard from "../../../components/shared/infocard/InfoCard";
import Datatable from "../../../components/shared/datatable/Datatable";
import { PlusSvg } from "../../../svgFiles/PlusSvg";
import Button from "../../../components/shared/buttons/button";
import CheeksStripsModal from "./CheeksStripsModal";
import { PackedBoxModal } from "./PackedBoxModal";
import { formatDateAndTimeFromUTC } from "../../../components/shared/utils";
import {
  useGetBrokerageBoxesPackedDataQuery,
  useGetBrokeragePackingDataQuery,
  useGetBrokerageSummaryQuery,
} from "../materialEntered/materialApi";
import { EditSvg } from "../../../svgFiles/EditSvg";
import useTranslator from "../../../hooks/useTranslator";
import { convertToUserTimezone, formatDateAndTime, getCurrentDate } from "../../../helpers/Utils";
import { PROJECT_DATE_FORMAT } from "../../../helpers/constants";
const BrokeragePacking = () => {
  const { _t } = useTranslator();  
  const currentDate = getCurrentDate("YYYY-MM-DD");
  const [date, setDate] = useState(currentDate);
  const [page, setPage] = useState(1);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [activeTab, setActiveTab] = useState("cheeks");
  const [addData, setAddData] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [addPackingData, setAddPackingData] = useState(false);
  const [modalMode, setModalMode] = useState("");
  const [modalEditMode, setModalEditMode] = useState("");
  const [lotNumber , setLotNumber] = useState(getCurrentDate("DDMMYY"));
  const { data: cheekBoxes } = useGetBrokerageBoxesPackedDataQuery({
    date,
    type: "cheek",
  });
  const { data: stripeBoxes } = useGetBrokerageBoxesPackedDataQuery({
    date,
    type: "stripe",
  });
  const { data: pieceBoxes } = useGetBrokerageBoxesPackedDataQuery({
    date,
    type: "piece",
  });

  const { data: summaryData } = useGetBrokerageSummaryQuery({
    date,
    tab: "packaging",
  });

  // const { data: matricsData } = useGetBrokerageSummaryQuery({
  //   date,
  //   tab: "metrics",
  // });
  // const { data: cheekPackingDataLog } = useGetBrokeragePackingDataQuery({
  //   type: "cheek",
  //   date,
  // });
  // const { data: stripPackingDataLog } = useGetBrokeragePackingDataQuery({
  //   type: "stripe",
  //   date,
  // });
  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };
  const handleCheeksPacked = () => {
    setAddPackingData(true);
    setModalMode("cheek");
    setSelectedRecord(null);
    setShowModal(true);
    setModalEditMode("add");
  };
  const handleEditCheeksPacked = (data) => {
    setAddPackingData(true);
    setModalMode("cheek");
    setSelectedRecord(data);
    setShowModal(true);
    setModalEditMode("edit");
  };
  const handleEditStripsPacked = (data) => {
    setAddPackingData(true);
    setModalMode("stripe");
    setSelectedRecord(data);
    setShowModal(true);
    setModalEditMode("edit");
  };
  const handleStripsPacked = () => {
    setAddPackingData(true);
    setModalMode("stripe");
    setSelectedRecord(null);
    setShowModal(true);
    setModalEditMode("add");
  };
  const handlePiecesPacked = () => {
    setAddPackingData(true);
    setModalMode("piece");
    setSelectedRecord(null);
    setShowModal(true);
    setModalEditMode("add");
  };
  const handleEditPiecesPacked = (data) => {
    setAddPackingData(true);
    setModalMode("piece");
    setSelectedRecord(data);
    setShowModal(true);
    setModalEditMode("edit");
  };

  
  useEffect( () => {
    setLotNumber(convertToUserTimezone(date,"DDMMYY"));
  },[date]);

  const listItems = [
    {
      label: _t("total_kg_entered", "Total KG Entered"),
      value: summaryData?.kg_selected ?? 0,
      icon: Box,
    },
    {
      label: _t("total_cheeks_kg_entered", "Total Cheeks KG Entered"),
      value: summaryData?.total_cheeks_kg_entered ?? 0,
      icon: Box,
    },
    {
      label: _t("total_strips_kg_entered", "Total Strips KG Entered"),
      value: summaryData?.total_strips_kg_entered ?? 0,
      icon: BoxGreen,
    },
    {
      label: _t("total_pieces_kg_entered", "Total Pieces KG Entered"),
      value: summaryData?.total_pieces_kg ?? 0,
      icon: BoxGreen,
    },
    {
      label: _t("total_cheeks_packed", "Total Cheeks Packed"),
      value: summaryData?.total_cheeks_packed ?? 0,
      icon: BoxGreen,
    },
    {
      label: _t("total_stripes_packed", "Total Stripes Packed"),
      value: summaryData?.total_stripes_packed ?? 0,
      icon: BoxGreen,
    },

    {
      label: _t("total_pieces_packed", "Total Pieces Packed"),
      value: summaryData?.total_pieces_packed ?? 0,
      icon: BoxGreen,
    },
    // {
    //   label: _t("total_prime_kg", "Total Prime KG"),
    //   value: summaryData?.total_prime_kg ?? 0,
    //   icon: Box,
    // },
    // {
    //   label: _t("total_prime_lite_kg", "Total Second KG"),
    //   value: summaryData?.total_prime_lite_kg ?? 0,
    //   icon: BoxGreen,
    // },
    // {
    //   label: _t("total_trash_kg", "Total Trash KG"),
    //   value: summaryData?.total_trash_kg ?? 0,
    //   icon: BoxGreen,
    // },
  ];

  // const generateMatricsData = (matricsData, prefix) => {
  //   const config = [
  //     {
  //       label: `${_t("total", "Total")} ${prefix} ${_t(
  //         "kg_prime",
  //         "KG Prime"
  //       )}`,
  //       key: `total_${prefix.toLowerCase()}_kg_prime`,
  //     },
  //     {
  //       label: `${_t("total", "Total")} ${prefix} ${_t(
  //         "kg_second",
  //         "KG Second"
  //       )}`,
  //       key: `total_${prefix.toLowerCase()}_kg_prime_lite`,
  //     },
  //     {
  //       label: `${_t("total", "Total")} ${_t("kg_waste", "KG Waste")}`,
  //       key: `total_${prefix.toLowerCase()}_kg_waste`,
  //     },
  //     {
  //       label: `${_t("total", "Total")} ${_t(
  //         "prime_percentage_day",
  //         "Prime % End of Day"
  //       )}`,
  //       key: `total_${prefix.toLowerCase()}_prime_perc`,
  //       isPercentage: true,
  //     },
  //   ];

  //   return config.map((item) => ({
  //     label: item.label,
  //     value: item.isPercentage
  //       ? `${(matricsData?.[item.key] ?? 0).toFixed(2)}%`
  //       : `${matricsData?.[item.key] ?? 0}`,
  //   }));
  // };

  // const cheekDataMatrics = generateMatricsData(matricsData, "Cheeks");
  // const stripDataMatrics = generateMatricsData(matricsData, "Stripe");

  const columns = [
    {
      label: _t("time", "Time"),
      accessor: "created_at",
      cell: ({ value }) => {
        return formatDateAndTimeFromUTC(value).time;
      },
    },

    { label: "Fruit Type", accessor: "fruit_name" },
    activeTab === "cheeks"
      ? {
          label: _t("cheeks_kg", "Cheeks KG"),
          accessor: "cheeks_entered_kg",
        }
      : {
          label: _t("strips_kg", "Strips KG"),
          accessor: "stripes_entered_kg",
        },
    {
      label: _t("prime_kg", "Prime KG"),
      accessor: "prime_kg",
    },
    {
      label: _t("second_kg", "Second KG"),
      accessor: "prime_lite_kg",
    },
    {
      label: _t("trash_kg", "Trash KG"),
      accessor: "trash_kg",
    },
    {
      label: _t("edit_view", "Edit/View"),
      accessor: "type",
      cell: ({ row }) => {
        return (
          <Button
            size="small"
            label="Edit"
            onClick={() => handleEditMaterial(row)}
            className=""
            // disabled={isDisabled} // Disable button if total_kg is 0
          />
        );
      },
    },
  ];
  const generatePackedData = (boxData, labelPrefix) => {
    const data = boxData?.data?.data[0] || {};
    if (labelPrefix === "Cheeks" || labelPrefix === "Strips") {
      return [
        {
          label: `${_t(
            "prime 10 pounds",
            "Prime 10 pounds"
          )} ${labelPrefix} ${_t("packed", "Packed")}`,
          value: `${data.prime_type_one ?? 0}`,
        },
        {
          label: `${_t(
            "prime 20 pounds",
            "Prime 20 pounds"
          )} ${labelPrefix} ${_t("packed", "Packed")}`,
          value: `${data.prime_type_two ?? 0}`,
        },
        {
          label: `${_t(
            "second 20 pounds",
            "Second 20 pounds"
          )} ${labelPrefix} ${_t("packed", "Packed")}`,
          value: `${data.prime_lite_type_two ?? 0}`,
        },
        {
          label: `${_t("total", "Total")} ${labelPrefix} ${_t(
            "pallets_ready",
            "Pallets Ready"
          )}`,
          value: `${data.total_pallets ?? 0}`,
        },
      ];
    }

    return [
      {
        label: `${_t("20 pounds", "20 pounds")} ${labelPrefix} ${_t(
          "packed",
          "Packed"
        )}`,
        value: `${data.piece_type_two ?? 0}`,
      },
      {
        label: `${_t("total", "Total")} ${labelPrefix} ${_t(
          "pallets_ready",
          "Pallets Ready"
        )}`,
        value: `${data.total_pallets ?? 0}`,
      },
    ];
  };
  const cheeksBoxesPackedData = generatePackedData(cheekBoxes, "Cheeks");
  const stripsBoxesPackedData = generatePackedData(stripeBoxes, "Strips");
  const piecesBoxesPackedData = generatePackedData(pieceBoxes, "Pieces");
  const handleAddMaterial = () => {
    setAddData(true);
    setModalMode("add");
    setSelectedRecord(null);
    setShowModal(true);
  };
  const handleEditMaterial = (data) => {
    setAddData(true);
    setModalMode("edit");
    setSelectedRecord(data);
    setShowModal(true);
  };
  const renderPackedButton = (boxData, handleEdit, handleAdd) => {
    return boxData?.data?.data.length > 0 ? (
      <Button
        size="xs"
        label="Edit Data"
        icon={<EditSvg color="#fff" />}
        onClick={() => handleEdit(boxData?.data?.data)}
      />
    ) : (
      <Button
        size="xs"
        label={_t("add_data", "Add Data")}
        icon={PlusSvg}
        onClick={handleAdd}
      />
    );
  };

  // console.log(`addData :: ${addData} || addPackingData :: ${addPackingData}`);

  return (
    <div>
      {addData && (
        <CheeksStripsModal
          show={showModal}
          setShow={setAddData}
          mode={modalMode}
          record={selectedRecord}
          acttiveTab={activeTab}
        />
      )}
      {addPackingData && (
        <PackedBoxModal
          show={showModal}
          setShow={setAddPackingData}
          mode={modalMode}
          record={selectedRecord}
          editMode={modalEditMode}
          lot_number_id={lotNumber}
        />
      )}
      <div className="overview cmn_card mb-3">
        <div className="overview_header d-flex gap-2 align-items-center">
          <h6 className="mb-0 flex-grow-1">{_t("overview", "Overview")}</h6>
            <Button
              // onClick={AddEmployee}
              label={`#${lotNumber}`}
              size="small"
              className="borderRedBtn"
            />
          <DateSelector setDate={setDate} />
        </div>
        <ul className="m-0 grid_card_wrapper">
          {listItems.map((list, index) => (
            <GridCard
              key={index}
              title={list.label}
              value={list.value}
              icon={list.icon}
              day={currentDate === date ? _t("today", "Today") : formatDateAndTime(date ,PROJECT_DATE_FORMAT)}
            />
          ))}
        </ul>
      </div>
      {/* <div>
        <h6 className="my-3">Matrics</h6>
        <div className="overview cmn_card">
          <div className="overview-card">
            <Row>
              <Col lg={6} className="border-end ">
                <h6 className="overview_header">{_t("cheeks", "Cheeks")}</h6>
                <div className="p-3">
                  <Row>
                    {cheekDataMatrics.map((item, index) => (
                      <Col lg={6} key={index}>
                        <InfoCard label={item.label} value={item.value} />
                      </Col>
                    ))}
                  </Row>
                </div>
              </Col>
              <Col lg={6}>
                <h6 className="overview_header">{_t("strips", "Strips")}</h6>
                <div className="p-3">
                  <Row>
                    {stripDataMatrics.map((item, index) => (
                      <Col lg={6} key={index}>
                        <InfoCard label={item.label} value={item.value} />
                      </Col>
                    ))}
                  </Row>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div> */}
      {/* <div className="my-3">
        <Datatable
          title={_t("cheeks_strips_log", "Cheeks/Strips Log")}
          columns={columns}
          page={page}
          tableData={
            activeTab === "cheeks"
              ? cheekPackingDataLog?.data
              : stripPackingDataLog?.data
          }
          showCount={false}
          showPegination={false}
          tab={true}
          activeTab={activeTab}
          onTabChange={handleTabClick}
          buttons={[
            {
              label: _t("add_brokerage_material", "Add Brokerage Material"),
              icon: PlusSvg,
              onClick: handleAddMaterial,
            },
          ]}
        />
      </div> */}
      <div className="my-3">
        <h6 className="mb-3">{_t("packed_boxes_log", "Packed Boxes Log")}</h6>
        <div className="gap-2  overviewcard">
          <Row>
            <Col lg={6}>
              <div className="dash_card h-100">
                <div className="d-flex justify-content-between align-items-center dash_header">
                  <div className="d-flex card_heading align-items-center">
                    <h3 className="mb-0">
                      {_t("cheeks_boxes_packed", "Cheeks Boxes Packed")}
                      {`(Code.  #${lotNumber})`}{" "}
                    </h3>
                  </div>
                  {date === currentDate &&
                    renderPackedButton(
                      cheekBoxes,
                      handleEditCheeksPacked,
                      handleCheeksPacked
                    )}
                </div>
                <div className="p-3">
                  <Row>
                    {cheeksBoxesPackedData.map((item, index) => (
                      <Col lg={6} key={index}>
                        <InfoCard label={item.label} value={item.value} />
                      </Col>
                    ))}
                  </Row>
                </div>
              </div>
            </Col>
            <Col lg={6}>
              <div className="dash_card h-100">
                <div className="d-flex justify-content-between align-items-center dash_header">
                  <div className="d-flex card_heading align-items-center">
                    <h3 className="mb-0">
                      {_t("strips_boxes_packed", "Strips Boxes Packed")}
                      {`(Code.  #${lotNumber})`}{" "}
                    </h3>
                  </div>
                  {date === currentDate &&
                    renderPackedButton(
                      stripeBoxes,
                      handleEditStripsPacked,
                      handleStripsPacked
                    )}
                </div>
                <div className="p-3">
                  <Row>
                    {stripsBoxesPackedData.map((item, index) => (
                      <Col lg={6} key={index}>
                        <InfoCard label={item.label} value={item.value} />
                      </Col>
                    ))}
                  </Row>
                </div>
              </div>
            </Col>
            <Col lg={6} className="mt-3">
              <div className="dash_card h-100">
                <div className="d-flex justify-content-between align-items-center dash_header">
                  <div className="d-flex card_heading align-items-center">
                    <h3 className="mb-0">
                      {_t("pieces_boxes_packed", "Pieces Boxes Packed")}
                      {`(Code.  #${lotNumber})`}{" "}
                    </h3>
                  </div>
                  {date === currentDate &&
                    renderPackedButton(
                      pieceBoxes,
                      handleEditPiecesPacked,
                      handlePiecesPacked
                    )}
                </div>
                <div className="p-3">
                  <Row>
                    {piecesBoxesPackedData.map((item, index) => (
                      <Col lg={6} key={index}>
                        <InfoCard label={item.label} value={item.value} />
                      </Col>
                    ))}
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default BrokeragePacking;
